// src/client/components/NavBar.tsx
// Floating translucent bottom nav. 5 tabs: Home, Loans, Score, Apply, Profile.
// Active route gets the primary gradient background.
import { NavLink } from 'react-router-dom';
import { Home, Clock, TrendingUp, CreditCard, User } from 'lucide-react';
import { ROUTES } from '@/constants/routes';
import styles from './NavBar.module.css';

const ITEMS = [
  { to: ROUTES.home,      label: 'Home',    Icon: Home },
  { to: ROUTES.loansList, label: 'Loans',   Icon: Clock },
  { to: ROUTES.score,     label: 'Score',   Icon: TrendingUp },
  { to: ROUTES.loanApply, label: 'Apply',   Icon: CreditCard },
  { to: ROUTES.profile,   label: 'Profile', Icon: User },
] as const;

export default function NavBar() {
  return (
    <nav className={styles.nav} aria-label="Primary">
      <ul className={styles.list}>
        {ITEMS.map(({ to, label, Icon }) => (
          <li key={to}>
            <NavLink
              to={to}
              className={({ isActive }) =>
                [styles.item, isActive && styles.active].filter(Boolean).join(' ')
              }
              end
            >
              <Icon size={20} aria-hidden />
              {/* Label is RIGHT of icon — slides in when active */}
              <span className={styles.label}>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
